import { REFRESH_KEY, COOKIE_KEY, EXPIRY_THRESHOLD, REFRESHING_TOKEN_KEY } from '../constants';
import getAccessToken from './get-access-token';
import decodeAccessToken from './decode-access-token';
import handleRefresh from './handle-refresh';
import providerHandler from './provider-handler';
const checkAccessToken = (client, ctx = null) => {
  if (typeof window === 'undefined' || !client || window.localStorage.getItem(REFRESHING_TOKEN_KEY)) {
    return null;
  }
  const refreshToken = window.localStorage.getItem(REFRESH_KEY);
  if (!refreshToken) return providerHandler.autoLogin(client, ctx);
  const token = getAccessToken(COOKIE_KEY);
  const {
    exp
  } = decodeAccessToken(token);
  const dateNow = new Date();
  const currentTime = dateNow.getTime() / 1000;
  const shouldRefresh = refreshToken && !exp || exp < currentTime || exp - currentTime <= EXPIRY_THRESHOLD;
  if (!shouldRefresh) return null;
  return handleRefresh(refreshToken, client);
};
export default checkAccessToken;
//# sourceMappingURL=check-access-token.js.map